/**
 * `kanbanSettingsFromMonday()` — read monday's `KanbanBoardView.settings_str`
 * (`specs/M4-V2-kanban.md` §4). Pure and total: it never throws on real data, anything it
 * does not model is preserved in `mondayExtras`, and the key set monday stored is preserved
 * in `mondayKeys` so `kanbanSettingsToMonday()` reproduces the original object exactly.
 *
 * Tested against **all nine** production rows in
 * `packages/shared/src/views/__fixtures__/monday-view-settings.json`.
 */
import { columnSelectionFromMonday, singleColumnFromMonday } from '../column-selection.js';
import { extraKeys, parseViewSettingsBlob, presentKeys } from '../from-monday.js';
import { DEFAULT_KANBAN_VIEW_SETTINGS, KANBAN_MONDAY_KEYS } from './index.js';
export function kanbanSettingsFromMonday(raw) {
    const { object, warnings } = parseViewSettingsBlob(raw, 'kanban');
    const displayModeRaw = object['display_mode'];
    let coverDisplayMode = DEFAULT_KANBAN_VIEW_SETTINGS.coverDisplayMode;
    if (displayModeRaw === 'crop' || displayModeRaw === 'fit')
        coverDisplayMode = displayModeRaw;
    else if (displayModeRaw !== undefined) {
        warnings.push(`kanban: unknown display_mode ${JSON.stringify(displayModeRaw)}`);
    }
    return {
        settings: {
            pivotColumnId: singleColumnFromMonday(object['pivot_by_column']),
            assigneeColumnId: singleColumnFromMonday(object['assignee_column']),
            cardColumns: columnSelectionFromMonday(object['card_columns']),
            coverColumns: columnSelectionFromMonday(object['gallery_column']),
            coverDisplayMode,
            divideByGroup: object['divide_by_group'] === true,
            hideEmptyGroups: object['hide_empty_groups'] === true,
            collapsedLaneKeys: [],
            mondayKeys: presentKeys(object, KANBAN_MONDAY_KEYS),
            mondayExtras: extraKeys(object, KANBAN_MONDAY_KEYS),
        },
        warnings,
    };
}
//# sourceMappingURL=from-monday.js.map